import * as React from 'react';
import ReactPlayer from 'react-player/lazy';
import { EPlayerIconType } from '../VideoPreview/Icons';
import { VideoPreview } from '../VideoPreview';

import * as styles from './styles.css';
import { TVideoType } from '../../types/newbuilding/media';
import { VKVideo } from '../VKVideo';
import { RutubePlayer } from '../RutubePlayer';

export interface IVideoPlayerProps {
  isFullscreenSlideActive?: boolean;
  fullUrl: string;
  videoUrl: string;
  type: TVideoType;
}

interface IVideoPlayerState {
  isActive: boolean;
}

export class VideoPlayer extends React.Component<IVideoPlayerProps, IVideoPlayerState> {
  public state: IVideoPlayerState = {
    isActive: Boolean(this.props.isFullscreenSlideActive),
  };

  public static getDerivedStateFromProps(props: IVideoPlayerProps, state: IVideoPlayerState) {
    if (state.isActive && props.isFullscreenSlideActive === false) {
      return { isActive: false };
    }

    return null;
  }

  public render() {
    const { isActive } = this.state;

    const content = isActive ? this.renderPlayer() : this.renderPreview();

    return <div className={styles['videoContainer']}>{content}</div>;
  }

  private renderPreview = () => {
    return (
      <VideoPreview
        url={this.props.fullUrl}
        onClick={this.handlePreviewClick}
        iconType={EPlayerIconType.Normal}
        fit="contain"
      />
    );
  };

  private renderPlayer = () => {
    switch (this.props.type) {
      case 'youtube':
        return <ReactPlayer url={this.props.videoUrl} width="100%" height="100%" controls playing />;
      case 'rutube':
        return <RutubePlayer src={this.props.videoUrl} />;
      case 'vk':
      default:
        return <VKVideo src={this.props.videoUrl} />;
    }
  };

  private handlePreviewClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();

    this.setState({
      isActive: true,
    });
  };
}
